import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';

function Addblog() {
const navigate =useNavigate();
    const [imagePreview, setImagePreview] = useState(true);

    // IMAGE PREVIEW
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setImagePreview(URL.createObjectURL(file));
        }
    };

    return (
        <div>

            {/* PAGE HEADER */}
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Add Blog</h4>

                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="breadcrumb-item">
                                Add Blog
                            </li>
                        </ol>
                    </nav>
                </div>
                     <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        Blog List

                    </button>

                </div>
            </div>

            {/* BLOG FORM */}
            <div className="card border-0 shadow-sm rounded-4 add_blog_card">
                <div className="card-body p-4">

                    <div className="row">

                        {/* BLOG TITLE */}
                        <div className="col-md-12 mb-4">
                            <label className="form-label fw-semibold">
                                Blog Title
                            </label>

                            <input
                                type="text"
                                className="form-control custumform"
                                placeholder="Enter Blog Title"
                            />
                        </div>

                        {/* BLOG IMAGE */}
                        <div className="col-md-6 mb-4">

                            <label className="form-label fw-semibold">
                                Upload Image
                            </label>

                            <input
                                type="file"
                                className="form-control custumform"
                                accept="image/*"
                                onChange={handleImageChange}
                            />

                            {/* IMAGE PREVIEW */}
                            {imagePreview && (
                                <div className="blog_image_preview mt-3">
                                    <img
                                        src={imagePreview}
                                        alt="Preview"
                                        className="blog_preview_img"
                                    />
                                </div>
                            )}

                        </div>

                        {/* BLOG DESCRIPTION */}
                        <div className="col-md-6 mb-4">
                            <label className="form-label fw-semibold">
                                Description
                            </label>

                            <textarea
                                rows="8"
                                className="form-control custumform blog_textarea"
                                placeholder="Enter Blog Description"
                            ></textarea>
                        </div>

                        {/* SUBMIT BUTTON */}
                        <div className="col-md-12">
                            <div className="text-end">
                                <button className="blog_submit_btn">
                                    Submit Blog
                                </button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}

export default Addblog;